import {Button, Icon, Text} from '@gravity-ui/uikit';
import {FileText, TrashBin} from '@gravity-ui/icons';
import {formatFileSize} from '../../lib';
import styles from './FilePreviewInformation.module.scss';

interface FilePreviewInformationProps {
  fileName: string | null;
  fileSize: number | null;
  handleRemoveFile: () => void;
}

export const FilePreviewInformation = ({fileName, fileSize, handleRemoveFile}: FilePreviewInformationProps) => {
  return (
    <div className={styles.fileInfo}>
      <div className={styles.fileDetails}>
        <Icon data={FileText} size={16} className={styles.fileIcon} />
        <div className={styles.fileText}>
          <Text variant="body-1">{fileName}</Text>
          <Text className={styles.fileSize}>({fileSize ? formatFileSize(fileSize) : ''})</Text>
        </div>
      </div>
      <Button view="flat" size="s" onClick={handleRemoveFile} className={styles.removeButton}>
        <Icon data={TrashBin} size={16} />
      </Button>
    </div>
  );
};
